import { render, staticRenderFns } from "./BurnedFTM.vue?vue&type=template&id=779acb73&"
import script from "./BurnedFTM.vue?vue&type=script&lang=js&"
export * from "./BurnedFTM.vue?vue&type=script&lang=js&"
import style0 from "./BurnedFTM.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports